import axios from "axios";



import { message as toaster } from "antd";
import Cookies from "universal-cookie";

export const globalDomain = process.env.REACT_APP_API_URL;
export const api_url = process.env.REACT_APP_API_URL;

const deleteAllCookies = () => {
  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

async function clearCookies() {

  new Promise((resolve) => {
    resolve(
      setTimeout(() => {
        const cookies = new Cookies();

        const all = cookies.getAll();

        Object.keys(all).forEach((key) => {
          cookies.remove(`${key}`, {
            path: "/",
          });
        });

        deleteAllCookies()
      }, 500)
    );

    localStorage.clear();

  });

  return

}



let authErrors = [];

//Retorno de mensagens de erro
const errosStatusMessage = {
  400: (error) => {

    const data = error.response?.data
    const message = data?.log ?? data?.message ?? "Requisição inválida";

    return { ...data, message };
  },
  401: (error) => {

    //limpa o storage e da reload na pagina
    clearCookies();
    // window.location.reload();

    return {
      unauthenticated: true,
      message: "Usuário não autenticado, faça login novamente",
    };

  },
  403: (error) => {
    const message =
      error?.response?.data?.message ??
      "Você não tem permissão para acessar esse recurso";
    return { ...error, message };
  },
  404: () => {
    return { message: "Recurso não encontrado" };
  },
  406: (error) => {
    const message =
      error?.response?.data?.message ??
      "Não foi possível processar a requisição";
    return { message };
  },
  419: (error) => {
    localStorage.clear();
    clearCookies();
    errosStatusMessage[401](error);
  },
  422: (error) => {
    const messages = error?.response?.data?.errors;
    for (const key in messages) {
      if (messages.hasOwnProperty(key)) toaster.error(messages[key][0]);
    }

    return { messages };
  },
  429: () => {
    return { message: "Muitas requisições, tente novamente mais tarde" };
  },
  500: () => {
    return { message: "Erro interno do servidor" };
  },
}


export const api = axios.create({
  baseURL: globalDomain,
  withCredentials: true,
});



//Interceptores de requisição para tratar os erros
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {

    const status = error?.response?.status;

    if (status === 401 || status === 419) authErrors.push(error.response);

    if (errosStatusMessage[status])
      return Promise.reject({
        ...error,
        ...errosStatusMessage[status](error),
      });
    else
      return Promise.reject({
        ...error,
        message: "Ocorreu um erro inesperado, tente novamente mais tarde",
      });
  }
);

api.interceptors.request.use(
  (config) => {
    //Configuração CSRF do axios
    config.xsrfCookieName = "XSRF-TOKEN";
    config.xsrfHeaderName = "X-XSRF-TOKEN";

    //Aplicação concatenar json e html
    config.headers.Accept = "application/json, text/html";

    return config;
  },
  (error) => {
    const status = error?.response?.status

    if (status === 401 || status === 419) authErrors.push(error.response);

    if (authErrors.length > 1) {
      localStorage.clear();
      clearCookies();
      authErrors = []
    }

    if (errosStatusMessage[status])
      return Promise.reject({
        ...error,
        ...errosStatusMessage[status](error),
      });
    else
      return Promise.reject({
        ...error,
        message: "Ocorreu um erro inesperado, tente novamente mais tarde",
      });
  }
);
